// extracted by mini-css-extract-plugin
export var active = "_kz-2";
export var recordingDot = "_kz-1";
export var recordingIndicator = "_kz-0";